// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { ItemType } from '@rensa/shared/enums/item-type.enum';
import { Environment } from './definition';

export const environment: Environment = {
    apiBaseUrl: 'https://tstacademyfunapi.azurewebsites.net/api',
    apiBaseUrlAdmin: `https://tstacademyfunapi.azurewebsites.net/api/cms`,
    isProduction: false,
    frontendUrl: 'https://tst-academy.rensa.nl',
    contactEmail: 'academy@rensa.nl',
    AADClientId: '70793a8f-18c1-4554-b8aa-ced2a3647815',
    AADTenantId: 'https://login.microsoftonline.com/0a6cd777-7ec7-4ebd-8002-941b7e884de7',
    AADRedirectUri: 'https://tst-academy.rensa.nl',
    itemType: ItemType.Trainingen,
    sendToEmail: [
        {
            subject: 'Interessante kenniscafé bij Rensa, iets voor jou?',
            itemOverview: {
                body: "Beste collega,\n\nIk zag dit kenniscafé '{{title}}' voorbijkomen bij Rensa Verwarming & Ventilatie. Wellicht is dit interessant voor jou.\n\nBekijk dit kenniscafé op {{link}} en meld je aan.\n\nGroet",
            },
            itemDetail: {
                body: "Beste collega,\n\nIk zag dit kenniscafé '{{title}}' voorbijkomen bij Rensa Verwarming & Ventilatie, deze vindt plaats in {{location}} op {{date}}. Wellicht is dit interessant voor jou.\n\nBekijk dit kenniscafé op {{link}} en meld je aan.\n\nGroet",
            },
        },
        {
            subject: 'Interessante training bij Rensa, iets voor jou?',
            itemOverview: {
                body: "Beste collega,\n\nIk zag deze training '{{title}}' voorbijkomen bij Rensa Verwarming & Ventilatie. Wellicht is dit interessant voor jou.\n\nBekijk de training op {{link}} en meld je aan.\n\nGroet",
            },
            itemDetail: {
                body: "Beste collega,\n\nIk zag deze training '{{title}}' voorbijkomen bij Rensa Verwarming & Ventilatie, deze vindt plaats in {{location}} op {{date}}. Wellicht is dit interessant voor jou.\n\nBekijk de training op {{link}} en meld je aan.\n\nGroet",
            },
        },
    ],
    roles: {
        cms: 'AcademyCMS',
        host: 'HostCMS',
    },
    menuItems: [
        {
            text: 'Home',
            url: '/',
        },
        {
            text: 'Trainingen',
            url: '/trainingen',
        },
        {
            text: 'Kenniscafé',
            url: '/kenniscafe',
        },
        {
            text: 'TechTalk',
            url: 'https://rensa.nl/academy/techtalk',
        },
        {
            text: 'Webinar',
            url: 'https://www.rensa.nl/academy/webinar',
        },
    ],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 *
 * import 'zone.js/dist/zone-error';  // Included with Angular CLI.
 */
